<template>
  <div>
    <!-- ‾\_(ツ)_/‾ -->
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>
